import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=8e884e10&scoped=true&"
import script from "./CaseList.vue?vue&type=script&lang=ts&"
export * from "./CaseList.vue?vue&type=script&lang=ts&"
import style0 from "./CaseList.vue?vue&type=style&index=0&id=8e884e10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e884e10",
  null
  
)

export default component.exports